import { render, staticRenderFns } from "./SummaryTable.vue?vue&type=template&id=be8e1346&scoped=true"
import script from "./SummaryTable.vue?vue&type=script&lang=ts"
export * from "./SummaryTable.vue?vue&type=script&lang=ts"
import style0 from "./SummaryTable.vue?vue&type=style&index=0&id=be8e1346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8e1346",
  null
  
)

export default component.exports